import { TableSizeOptions } from '../../components/TableSizeFilter/constants';
import { LimitOptions } from '../../components/LimitFilter/constants';
import { DateOptions } from '../../components/DateFilter/constants';
import { PokersiteOptions } from '../../components/PokersiteFilter/constants';
import type { CustomDateFilterValue } from '../../components/DateFilter/DateFilter';
import dayjs from 'dayjs';

export function getPokersiteLabel(value = 0) {
  const option = PokersiteOptions.find((item) => item.id === value);
  if (!option || option.id === 0) {
    return 'Все сети';
  }

  return option.label;
}

export function getTableSizeLabel(value?: number) {
  if (value == null) {
    return 'Все форматы';
  }

  return TableSizeOptions.find((option) => option.id === value)?.label ?? 'Все форматы';
}

export function getLimitLabel(value: number) {
  const option = LimitOptions.find((item) => item.id === value);
  if (!option || option.id === 0) {
    return 'Все лимиты';
  }

  return `NL${option.label}`;
}

export function getDateLabel(value?: number, customValue?: CustomDateFilterValue) {
  if (customValue?.fromDate && customValue?.toDate) {
    return `${dayjs(customValue.fromDate).format('DD.MM.YY')} – ${dayjs(customValue.toDate).format('DD.MM.YY')}`;
  }

  if (value == null) {
    return 'Всё время';
  }

  const labels: Record<number, string> = {
    1: 'Этот месяц',
    2: '3 месяца',
    3: '6 месяцев',
    4: '12 месяцев',
  };

  return labels[value] ?? DateOptions.find((option) => option.id === value)?.label ?? 'Всё время';
}

export function countActiveFilters(
  tableSize?: number,
  limit = 0,
  date?: number,
  customDate?: CustomDateFilterValue,
) {
  return (
    Number(tableSize != null) +
    Number(limit !== 0) +
    Number(date != null || Boolean(customDate?.fromDate && customDate?.toDate))
  );
}
